import { render } from "./TrainingModels.vue?vue&type=template&id=3d4ac0f8&scoped=true&ts=true"
import script from "./TrainingModels.vue?vue&type=script&lang=ts"
export * from "./TrainingModels.vue?vue&type=script&lang=ts"

import "./TrainingModels.vue?vue&type=style&index=0&id=3d4ac0f8&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4ac0f8"]])

export default __exports__